import Vue from 'vue'
import App from './App.vue'
import components from './components'
import Popover from 'vue-js-popover'

//Set global constants
Vue.prototype.$Home = 'Home';
Vue.prototype.$Intro = 'intro';
Vue.prototype.$Statements = 'statements';
Vue.prototype.$EntryAdded = 'entryAdded';
Vue.prototype.$NoEntriesAdded = 'noEntriesAdded';
Vue.prototype.$MyWellbeingDiary = 'myWellbeingDiary';
Vue.prototype.$StatementDetails = 'statementDetails';
Vue.prototype.$Share = 'share';
Vue.prototype.$helpAndSupport = 'helpAndSupport';

Vue.prototype.$answerNames = [
  "Disagree",
  "Neutral",
  "Agree",
  "Not answered"
];

Vue.config.productionTip = false
Vue.use(Popover);

new Vue({
  components,
  render: h => h(App),
}).$mount('#app')
